export default {
    "sProcessing": "Bezig...",
    "sLengthMenu": "_MENU_ resultaten weergeven",
    "sZeroRecords": "Geen resultaten gevonden",
    "sInfo": "_START_ tot _END_ van _TOTAL_ resultaten",
    "sInfoEmpty": "Geen resultaten om weer te geven",
    "sInfoFiltered": " (gefilterd uit _MAX_ resultaten)",
    "sInfoPostFix": "",
    "sSearch": "Zoeken:",
    "sEmptyTable": "Geen resultaten aanwezig in de tabel",
    "sInfoThousands": ".",
    "sLoadingRecords": "Een moment geduld aub - bezig met laden...",
    "oPaginate": {
        "sFirst": "<i class='bi bi-chevron-double-left' aria-label='Eerste pagina'></i>",
        "sLast": "<i class='bi bi-chevron-double-right'  aria-label='Laatste pagina'></i>",
        "sNext": "<i class='bi bi-chevron-right' aria-label='Volgende pagina'></i>",
        "sPrevious": "<i class='bi bi-chevron-left' aria-label='Vorige pagina'></i>"
    },
    "oAria": {
        "sSortAscending": ": activeer om kolom oplopend te sorteren",
        "sSortDescending": ": activeer om kolom aflopend te sorteren"
    },
    "buttons": {
        "selectAll": "Selecteer alles",
        "selectNone": "Selecteer niets"
    }
}
